import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "delete-supplier-modal";

const keys = addTranslations(RESOURCE_NAME, {
    delete_supplier_modal_title: {
        en: "Delete Supplier",
        fr: "Supprimer le fournisseur",
    },
    delete_supplier_modal_title_one: {
        en: "Delete Supplier",
        fr: "Supprimer le fournisseur",
    },
    delete_supplier_modal_title_other: {
        en: "Delete Suppliers",
        fr: "Supprimer les fournisseurs",
    },
    delete_supplier_modal_body: {
        en: "Are you sure you want to delete this supplier? This action is irreversible.",
        fr: "Êtes-vous sûr de vouloir supprimer ce fournisseur ? Cette action est irréversible.",
    },
    delete_supplier_modal_body_one: {
        en: "Are you sure you want to delete this supplier? This action is irreversible.",
        fr: "Êtes-vous sûr de vouloir supprimer ce fournisseur ? Cette action est irréversible.",
    },
    delete_supplier_modal_body_other: {
        en: "Are you sure you want to delete {{count}} suppliers? This action is irreversible.",
        fr: "Êtes-vous sûr de vouloir supprimer {{count}} fournisseurs ? Cette action est irréversible.",
    },
    delete_supplier_modal_cancel_button: {
        en: "Cancel",
        fr: "Annuler",
    },
    delete_supplier_modal_confirm_button: {
        en: "Delete",
        fr: "Supprimer",
    },
});

export function useDeleteSupplierModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
